<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <el-row>
        <el-col :span="24">
          <el-tabs v-model="tabActive">
            <el-tab-pane name="first">
              <div slot="label">
                申请中记录
                <span class="badge warning">{{ authorStat.ysqTk }}</span>
              </div>
              <MyRefundList1 v-if="tabActive=='first'"></MyRefundList1>
            </el-tab-pane>
            <el-tab-pane name="second">
              <div slot="label">
                退款成功记录
                <span class="badge success">{{ authorStat.tkCg }}</span>
              </div>
              <MyRefundList2 v-if="tabActive=='second'"></MyRefundList2>
            </el-tab-pane>
            <el-tab-pane name="third">
              <div slot="label">
                退款失败记录
                <span class="badge">{{ authorStat.tkSb }}</span>
              </div>
              <MyRefundList3 v-if="tabActive=='third'"></MyRefundList3>
            </el-tab-pane>
            <el-tab-pane name="fourth">
              <div slot="label">
                拒绝退款记录
                <span class="badge">{{ authorStat.bjTk }}</span>
              </div>
              <MyRefundList4 v-if="tabActive=='fourth'"></MyRefundList4>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import MyRefundList1 from "./MyRefundList1.vue"
import MyRefundList2 from "./MyRefundList2.vue"
import MyRefundList3 from "./MyRefundList3.vue"
import MyRefundList4 from "./MyRefundList4.vue"

export default {
  components: { PageHeader, MyRefundList1, MyRefundList2, MyRefundList3, MyRefundList4 },
  data() {
    return {
      headLinks: [{ path: "", title: "退款申请及记录" }],
      tabActive: "first",
    }
  },
  computed: {
    authorStat() {
      return this.$store.state.app.authorStat
    },
  },

  mounted() {},

  methods: {
    /* tabClick(tab) {
      if (tab.name == "first") {
        this.loadData()
      } else if (tab.name == "second") {
        this.loadData2()
      }
    }, */
  },
}
</script>

<style lang="scss" scoped></style>
